import React, { useEffect, useState } from 'react';
import { Alert, Button, Form, Modal, Spinner } from 'react-bootstrap';
import api from '../api/axiosConfig';
import { OrganizationDto } from '../types';

interface Props {
    show: boolean;
    clinic?: OrganizationDto | null;
    onClose: () => void;
    onSaved: () => void;
}

const ClinicModal: React.FC<Props> = ({ show, clinic, onClose, onSaved }) => {
    const [name, setName] = useState('');
    const [shortName, setShortName] = useState('');
    const [address, setAddress] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!show) return;
        setName(clinic?.name ?? '');
        setShortName(clinic?.shortName ?? '');
        setAddress(clinic?.address ?? '');
        setError(null);
    }, [show, clinic]);

    const submit = async (event: React.FormEvent) => {
        event.preventDefault();
        setSaving(true);
        setError(null);
        try {
            const payload = { name: name.trim(), shortName: shortName.trim() || null, address: address.trim() || null };
            if (clinic) await api.put(`/organizations/${clinic.id}`, payload);
            else await api.post('/organizations', payload);
            onSaved();
        } catch (e: any) {
            setError(e.response?.data?.message || 'Не удалось сохранить клинику');
        } finally { setSaving(false); }
    };

    return (
        <Modal show={show} onHide={onClose} centered>
            <Form onSubmit={submit}>
                <Modal.Header closeButton><Modal.Title>{clinic ? 'Редактировать клинику' : 'Новая клиника'}</Modal.Title></Modal.Header>
                <Modal.Body>
                    {error && <Alert variant="danger">{error}</Alert>}
                    <Form.Group className="mb-3"><Form.Label>Название</Form.Label><Form.Control required value={name} onChange={(e) => setName(e.target.value)} /></Form.Group>
                    <Form.Group className="mb-3"><Form.Label>Короткое имя</Form.Label><Form.Control value={shortName} onChange={(e) => setShortName(e.target.value)} /></Form.Group>
                    <Form.Group><Form.Label>Адрес</Form.Label><Form.Control as="textarea" rows={2} value={address} onChange={(e) => setAddress(e.target.value)} /></Form.Group>
                </Modal.Body>
                <Modal.Footer><Button variant="outline-secondary" onClick={onClose}>Отмена</Button><Button type="submit" disabled={saving}>{saving && <Spinner size="sm" className="me-2" />}Сохранить</Button></Modal.Footer>
            </Form>
        </Modal>
    );
};

export default ClinicModal;
